import styles from "../../../../../../styles/styles.module.css"

export const LabFive = () => {
  return (
    <div className={styles.book_container}>
      <div className={styles.book}>
        <div className={styles.book_content}>
          <h1 className={styles.title}>Phase Five</h1>
          <hr />




        </div>
      </div>
    </div >
  );
}
